module.exports = __webpack_public_path__ + "static/media/instagram.6a187bdd.svg";